<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Tickets Priority</h3>
            </div>
            <div class="col-6 text-right">
                <button type="button" class="button primary" @click="showModal()">Add Priority</button>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="fullname" slot-scope="props">
                    {{props.rowData.first_name}} {{props.rowData.middle_name}}
    
                </div>
    
            </vuetable>
        </div>
    
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
    
        </div>
    
        <b-modal ref="create-priority-modal" hide-footer title="Create Priority Tickets">
            
            <div class="l-form row">
                <div class="col-6">
                    <label>Priority</label>
                    <input type="text" v-model="priority" placeholder="Enter Priority">
                </div>
                <div class="col-6">
                    <label>SLA Hour</label>
                    <input type="number" v-model="sla">
                </div>
                <div class="col-12">
                    <label>Description</label>
                    <textarea rows="6" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="description" required />
                </div>
            </div>
            <b-button class="mt-3" variant="outline-success" block @click="createPriority" id="createPriority">Create Priority</b-button>
            <b-button class="mt-2" variant="outline-danger" block @click="hideModal">Cancel</b-button>
        </b-modal>
    
    
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",

    data() {
        return {
            priority: "",
            description: "",
            sla: 2,
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactive.api.casino.chezagame.com/tickets/v1/view/priority",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [{
                    name: "priority_id",
                    title: 'Priority ID',
                    sortField: "priority_id",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "priority",
                    title: "Priority",
                    sortField: "priority",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "priority_sla_hour",
                    title: "SLA (Hour)",
                    sortField: "priority_sla_hour",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "description",
                    title: "Description",
                    sortField: "description",
                    titleClass: "",
                    dataClass: ""
                },

                {
                    name: "created_at",
                    title: "Created At",
                    sortField: "created_at",
                    callback: "createdAt"
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "created_at",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            }
        };
    },

    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }
    },

    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },

    methods: {
        showModal(val) {
            this.selectedGame = val
            this.$refs['create-priority-modal'].show()
        },
        hideModal() {
            this.$refs['create-priority-modal'].hide()
            this.$refs.vuetable.refresh();
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },

        createPriority() {
            let vm = this
            $("#createPriority").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/create/priority',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    priority: vm.priority,
                    description: vm.description,
                    priority_sla_hour: vm.sla
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createPriority").text("Create Priority");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createPriority").text("Create Priority");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },

        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },

        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        }
    }
};
</script>
